import { TariffsProduct } from 'src/components/TariffPlans/types';

export function getAnalyticId(product: TariffsProduct) {
  switch (product) {
    case 'evolutionCloudServer':
      return 'evolution-cloud-server-card-calculator';
    case 'evolutionKubernetes':
    case 'evolutionKubernetesLandingPage':
      return 'evolution-kuber-card-calculator';
    case 'evolutionStorageS3':
      return 'evolution-storage-card-calculator';
    case 'evolutionBareMetal':
      return 'evolution-bare-metal-card-calculator';
    case 'evolutionCloudServerGpu':
      return 'evolution-cloud-server-gpu-card-calculator';
    case 'evolutionPostgreSql':
      return 'evolution-postgre-sql-card-calculator';
    case 'evolutionContainerApps':
      return 'evolution-container-apps-card-calculator';
    case 'evolutionMlInferenceInstanceTypeGpu':
    case 'evolutionMlInferenceModelSharedGpu':
      return 'evolution-ml-inference';
    default:
      return 'unknown-analytics-id';
  }
}
